import React from 'react';
import { Translate } from '~/i18n';
import { Button } from '~/components/common/button';
import { CheckGreenIcon } from '~/svgs/marketplace';
import { CloseIconGray } from '~/svgs';
import Modal from '~/components/common/modal';
import { Section } from '~/components/common/section';

type FilesUploadedModalType = {
   open: boolean;
   setOpen: (value: boolean) => void;
   setShowReviewState: (value: boolean) => void;
};

const FilesUploadedModal = ({ open, setOpen, setShowReviewState }: FilesUploadedModalType) => {
   return (
      <Modal size="sm" open={open}>
         <Section>
            <div className="px-5 pt-14 pb-10">
               <button
                  onClick={() => {
                     setOpen(false);
                     setShowReviewState(true);
                  }}
                  type="button"
                  className="absolute z-10 rounded-full focus:outline-none focus:ring-0 top-8 ltr:right-5 rtl:left-5 ">
                  <CloseIconGray />
               </button>
               <div className="flex flex-col items-center text-center space-y-4">
                  <CheckGreenIcon width={35} height={35} />
                  <div className="my-2 text-2xl font-bold capitalize px-20">
                     <Translate id="profile:documents uploaded" />
                  </div>
                  <div className="text-sm text-grey-300 px-10 pt-3 pb-5">
                     <Translate id="profile:documents uploaded description" />
                  </div>
               </div>
               <div className="flex justify-center p-4">
                  <Button
                     type="button"
                     theme="primary"
                     className="!w-1/2 !font-normal ml-2"
                     onClick={() => {
                        setOpen(false);
                        setShowReviewState(true);
                     }}>
                     <Translate id="common:continue" />
                  </Button>
               </div>
            </div>
         </Section>
      </Modal>
   );
};

export default FilesUploadedModal;
